<template>
  <div class="pointer active" @click="OnCreateWord">
    <el-button type="primary">下载到本地</el-button>
    <el-progress :percentage="percentage" style="margin-top: 8px"></el-progress>
  </div>
</template>

<script>
import docxtemplater from 'docxtemplater'
import PizZip from 'pizzip'
import JSZipUtils from 'jszip-utils'
import { saveAs } from 'file-saver'
import ImageModule from 'docxtemplater-image-module-free'

export default {
  props: {
    value: Object,
    config: Object,
    ExamTicketList: Array,
    UserCount: Number,
    CompleteCount: Number,
    NoComplete: Number
  },
  computed: {
    File() {
      return {
        Title: '企业学员培训记录',
        Url: '/static/File/Template.docx'
      }
    },
    SiteUrl() {
      return this.$matrix.Config.ImageSite
    },
    ExamDate() {
      if (this.value) {
        return this.value.CreateTime.substr(0, 7)
      }
    },
    ExamRange() {
      if (this.value) {
        let Year = new Date(this.value.CreateTime).getFullYear(),
          Month = new Date(this.value.CreateTime).getMonth() + 1,
          Day = new Date(Year, Month, 0).getDate()
        return `${Year}年${Month > 9 ? Month : '0' + Month}月01日-${Year}年${Month > 9 ? Month : '0' + Month}月${Day}日`
      }
    },
    LessonsTimeLen() {
      if (this.value && this.value.LessonsList && this.value.LessonsList.length) {
        return this.getDuration(
          this.value.LessonsList.reduce((t, n) => {
            return (t += n.LearnTime)
          }, 0)
        )
      }
    }
  },
  data() {
    return {
      percentage: 0,
      Total: 0,
      step: 0
    }
  },
  methods: {
    getDuration(seconds) {
      let m = Math.floor(seconds / 60)
      let s = Math.floor(seconds % 60)
      return `${m > 9 ? m : '0' + m}分${s > 9 ? s : '0' + s}秒`
    },
    async OnCreateWord() {
      console.log('收到的 props：', {
        ExamTicketList: this.ExamTicketList,
        UserCount: this.UserCount,
        CompleteCount: this.CompleteCount,
        NoComplete: this.NoComplete
      })
      let that = this
      this.percentage = 0
      this.step = 0
      this.Total = (this.ExamTicketList || []).length || 0

      // 用正确的导入名 JSZipUtils
      JSZipUtils.getBinaryContent(that.File.Url, async function (error, content) {
        if (error) throw error

        let processUsers = async () => {
          const list = that.ExamTicketList || []
          return Promise.all(
            list.map(async (item, index) => {
              return {
                Index: index + 1,
                NickName: item.Users?.NickName || '',
                Sex: item.Users?.Sex === 1 ? '男' : '女',
                IDCard: item.Users?.IDCard || '',
                ExamResult: item.ExamResult === 2 ? '通过' : '不通过',
                ExamScore: item.ExamScore || 0,
                FaceImage: item.Users?.FaceImage2 ? await that.getBase64Sync(that.SiteUrl + item.Users.FaceImage2) : ''
              }
            })
          )
        }

        let processedList = await processUsers()

        let WordData = {
          Name: that.value?.Title || '',
          Company: that.value?.Company?.Name || '',
          ExamRange: that.ExamRange || '',
          ExamDate: that.ExamDate || '',
          VideoCount: that.value?.VideoCount || 0,
          LessonsTimeLen: that.LessonsTimeLen || '00分00秒',
          UserCount: that.UserCount || 0,
          CompleteCount: that.CompleteCount || 0,
          NoComplete: that.NoComplete || 0,
          ExamTicketList: processedList
        }

        const opts = {
          centered: true,
          fileType: 'docx',
          getImage: (dataURL) => that.base64DataURLToArrayBuffer(dataURL),
          getSize: () => [100, 100]
        }
        const imageModule = new ImageModule(opts)

        let zip = new PizZip(content)
        let doc = new docxtemplater().loadZip(zip).attachModule(imageModule).setData(WordData)

        try {
          doc.render()
        } catch (error) {
          console.error(JSON.stringify({ error }))
          throw error
        }

        let out = doc.getZip().generate({
          type: 'blob',
          mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        })
        saveAs(out, `${that.value?.Title || '培训记录'}.docx`)
        that.percentage = 100
      })
    },
    getBase64Sync(ImageUrl) {
      return new Promise((resolve) => {
        let image = new Image()
        image.crossOrigin = 'anonymous'
        image.src = ImageUrl
        image.onload = () => {
          let canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height
          let ctx = canvas.getContext('2d')
          ctx.drawImage(image, 0, 0)
          let ext = image.src.split('.').pop().toLowerCase()
          let dataurl = canvas.toDataURL(`image/${ext}`, 0.1)
          this.step++
          this.percentage = Math.floor((this.step / this.Total) * 100)
          resolve(dataurl)
        }
      })
    },
    base64DataURLToArrayBuffer(dataURL) {
      const base64Regex = /^data:image\/(png|jpg|jpeg);base64,/
      if (!base64Regex.test(dataURL)) return false
      const stringBase64 = dataURL.replace(base64Regex, '')
      const binaryString = window.atob(stringBase64)
      const len = binaryString.length
      const bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) bytes[i] = binaryString.charCodeAt(i)
      return bytes.buffer
    }
  }
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>